import { AvailableWidget } from "ui/components/Grid/types";
import { FleetWarehouseDetailFormValues } from "services/api/fleet/warehouses/types";
import WarehouseInfoCard from "./components/WarehouseInfoCard/WarehouseInfoCard";
import WarehouseAddressCard from "./components/WarehouseAddressCard/WarehouseAddressCard";
import WarehouseContactCard from "./components/WarehouseContactCard/WarehouseContactCard";
import WarehouseWorkingHoursCard from "./components/WarehouseWorkingHoursCard/WarehouseWorkingHoursCard";

export const WAREHOUSE_AVAILABLE_WIDGETS = (
  t: (key: string) => string,
  fleetWarehouseDetail: FleetWarehouseDetailFormValues,
): AvailableWidget[] => [
  {
    id: "widget-warehouse-info",
    name: "Informacije o skladištu",
    icon: "",
    header: <></>,
    component: <WarehouseInfoCard fleetWarehouseDetail={fleetWarehouseDetail} />,
  },
  {
    id: "widget-warehouse-address",
    name: "Adresa",
    icon: "",
    header: <></>,
    component: <WarehouseAddressCard fleetWarehouseDetail={fleetWarehouseDetail} />,
  },
  {
    id: "widget-warehouse-working-hours",
    name: "Radno vrijeme",
    icon: "",
    header: <></>,
    component: <WarehouseWorkingHoursCard fleetWarehouseDetail={fleetWarehouseDetail} />,
  },
  {
    id: "widget-warehouse-contact",
    name: "Kontakti",
    icon: "",
    header: <></>,
    component: <WarehouseContactCard fleetWarehouseDetail={fleetWarehouseDetail} />,
  },
];
